import { css } from '@emotion/react';
import { ActionBarBoundary, ErrorBoundary } from '@frontend/error-boundary';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { shell } from '@frontend/shell-utils';
import { theme } from '@frontend/theme';
import { GlobalSearchView } from '../../global-search';

const hasNewShellTitleBar = shell?.isShell && shell?.featureAvailability?.has('shell-title-bar-view');
const hasShellThemeEnabled = shell?.isShell && shell?.featureAvailability?.has('shell-theme');

export const UniversalSearchView = () => {
  const isXSmall = useMatchMedia({ maxWidth: breakpoints.xsmall.max });
  const showGlobalSearch = isXSmall;
  const shouldHideInlineSearch = hasNewShellTitleBar && !showGlobalSearch;

  return (
    (hasNewShellTitleBar || !hasShellThemeEnabled || showGlobalSearch) && (
      <ErrorBoundary tier='feature' feature='universal-search' team='fe-ux-platform' fallback={ActionBarBoundary}>
        <GlobalSearchView
          css={[
            css`
              @media (min-width: ${breakpoints.large.min}px) {
                margin: 0 auto;
              }
              @media (max-width: ${breakpoints.mobile.max}px) and (min-width: ${breakpoints.small.min}px) {
                margin-left: auto;
              }
              .global-search__trigger {
                border-bottom: solid 2px transparent;
              }
              .global-search__trigger--open,
              .global-search__trigger--open:hover {
                border-bottom: solid 2px ${theme.colors.icon.select};
                :hover {
                  background: ${theme.colors.neutral5};
                }
                svg {
                  fill: ${theme.colors.icon.select};
                  color: ${theme.colors.icon.select};
                }
              }
            `,
            shouldHideInlineSearch &&
              css`
                position: fixed;
                top: 0;
                width: 1px;
                height: 1px;
                opacity: 0;
                pointer-events: none;
                overflow: hidden;
                right: 1px;
              `,
            shouldHideInlineSearch &&
              !window.shell?.isMac &&
              css`
                right: auto;
                left: 1px;
              `,
          ]}
        />
      </ErrorBoundary>
    )
  );
};
